export enum HTMLElementsIDs {
  MAIN_LAYOUT = 'MAIN_LAYOUT'
}
